import React, { useEffect } from "react";
import { useControls, useTransformContext } from "react-zoom-pan-pinch";

import { Image } from "@is/components/Image";
import { MediaVariants } from "@is/constants";
import { ENLARGED_SCALE_LEVELS } from "@is/constants/media";
import { useScreenOrientation } from "@is/hooks";

import css from "./EnlargeImage.module.css";

type Props = { url: string; active?: boolean };

const EnlargeImage = ({ url, active }: Props) => {
  const { resetTransform } = useControls();
  const { transformState } = useTransformContext();

  const { isPortraitView } = useScreenOrientation();

  useEffect(() => {
    if (transformState?.scale > ENLARGED_SCALE_LEVELS.MIN) {
      resetTransform(0);
    }
  }, [transformState, resetTransform, active]);

  return (
    <div className={css.mainMedia}>
      <Image
        src={url}
        mediavariant={MediaVariants.HUGE}
        placeholderMediaVariant={MediaVariants.LARGE}
        layout="contain"
        style={{
          width: isPortraitView ? "100%" : "auto",
          height: isPortraitView ? "auto" : "100%",
        }}
      />
    </div>
  );
};

export default EnlargeImage;
